/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'SafetyContactList',
    path: '/safety/contact-list',
    component: () =>
      import(
        /* webpackChunkName: "SafetyContactList" */ '@/views/safety/contact-list'
      ),
    meta: { title: ' ' },
  },
  {
    name: 'SafetyContactEdit',
    path: '/safety/contact-edit',
    component: () =>
      import(
        /* webpackChunkName: "SafetyContactEdit" */ '@/views/safety/contact-edit'
      ),
    meta: { title: ' ' },
  },
  {
    name: 'RecordProtect',
    path: '/safety/record-protect',
    component: () =>
      import(
        /* webpackChunkName: "RecordProtect" */ '@/views/safety/record-protect'
      ),
    meta: { title: '行程录音保护' },
  },
  {
    name: 'Safeguard',
    path: '/safety/safeguard',
    component: () =>
      import(/* webpackChunkName: "Safeguard" */ '@/views/safety/safeguard'),
    meta: { title: ' ' },
  },
];
